import React, { useState, useEffect } from "react";
import "./Pricing.css";
import { planList } from "../data/pricing/planList";

const Pricing = () => {
  const [isVisible, setIsVisible] = useState(true);

  // MB를 GB로 변환하는 함수
  const formatTraffic = (trafficMB) => {
    const trafficGB = trafficMB / 1000;
    return trafficGB >= 1 ? `${trafficGB} GB` : `${trafficMB} MB`;
  };
  // planList 객체를 배열로 변환하고 sortId로 정렬
  const plansArray = Object.entries(planList)
    .map(([key, plan]) => ({
      id: key,
      planName: key,
      ...plan,
    }))
    .sort((a, b) => a.sortId - b.sortId);

  const handleClose = () => {
    setIsVisible(false);
  };

  // 혜택 목록 생성 함수
  const getBenefits = (plan) => {
    const benefits = [
      `프로젝트 최대 ${plan.projects}개 배포`,
      `프로젝트 당 스토리지 ${plan.projectCapacity} MB 제공`,
      // `계정 당 총 메모리 ${plan.memory} MB 제공`,
      `계정 당 총 트래픽 ${formatTraffic(plan.traffic)} 제공`,
    ];

    if (plan.domains > 0) {
      benefits.push("도메인 연결 가능");
    }

    if (plan.extraBenefit?.traffic) {
      benefits.push(
        `트래픽 ${formatTraffic(plan.extraBenefit.traffic)} 추가 1회 무료`,
      );
    }

    return benefits;
  };

  return (
    <section className="pricing-section">
      <div className="wrap">
        <div className="text-box">
          <p className="title">
            <span className="eng">QWiK</span>에서는 요금제에 따라
            <br />더 많은 혜택을 제공하고 있습니다.
          </p>
        </div>
        <div className="plan-container">
          {plansArray.map((planItem) => (
            <div key={planItem.id} className="plan-box pos-rel">
              {planItem.isPopular && <div className="popular-badge">인기</div>}
              <span className="title">{planItem.planName}</span>
              <div className="explanation-box">{planItem.description}</div>
              <ul className="benefit-container">
                {getBenefits(planItem).map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>

              <div className="price-container">
                <div className="price">
                  {planItem.amount === null ? (
                    <span className="tbd">TBD</span>
                  ) : planItem.amount === 0 ? (
                    <span className="free">무료</span>
                  ) : (
                    <>
                      <span className="amount">
                        ₩{planItem.amount.toLocaleString()}
                      </span>
                      <span className="period">/월</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isVisible && (
        <div className="modal-bg">
          <div className="modal-popup pricing-notice-modal">
            <div className="text-box">
              <p>
                현재 <span className="eng">QWiK</span>은 테스트 운영 중으로,
              </p>
              <p>STARTER 요금제로만 이용 가능합니다.</p>
              <p>요금제 변경이 어려운 점, 양해 바랍니다.</p>
            </div>
            <div className="btn-box close-btn-box">
              <button className="accent" onClick={handleClose}>
                닫기
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Pricing;
